/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { ChallengeListInner } from './ChallengeListInner';
import {
    ChallengeListInnerFromJSON,
    ChallengeListInnerFromJSONTyped,
    ChallengeListInnerToJSON,
} from './ChallengeListInner';

/**
 * 
 * @export
 * @interface PostId200Response
 */
export interface PostId200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostId200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostId200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<ChallengeListInner>}
     * @memberof PostId200Response
     */
    result?: Array<ChallengeListInner>;
}

/**
 * Check if a given object implements the PostId200Response interface.
 */
export function instanceOfPostId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostId200ResponseFromJSON(json: any): PostId200Response {
    return PostId200ResponseFromJSONTyped(json, false);
}

export function PostId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : ((json['result'] as Array<any>).map(ChallengeListInnerFromJSON)),
    };
}

export function PostId200ResponseToJSON(value?: PostId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result === undefined ? undefined : ((value.result as Array<any>).map(ChallengeListInnerToJSON)),
    };
}

